import { z } from '../zod.js';

export const PaymentMethodValidationSchema = z.object({
  gateway: z.enum(['stripe', 'paypal', 'manual']).optional(),
  method: z.string().optional().meta({
    description: 'Payment method, such as card.',
  }),
  wallet: z.string().optional().meta({
    description: 'Wallet used for the payment method when applicable.',
  }),
  mode: z.enum(['default', 'express']).optional(),
  brand: z.string().optional().meta({
    description: 'Payment method brand, such as visa or mastercard.',
  }),
  last4: z.string().optional().meta({
    description: 'Last four digits of the payment method when available.',
  }),
  country: z.string().optional().meta({
    description: 'Country associated with the payment method when available.',
  }),
  exp_month: z.number().optional().openapi({
    description: 'Card expiration month.',
    deprecated: true,
  }),
  exp_year: z.number().optional().openapi({
    description: 'Card expiration year.',
    deprecated: true,
  }),
  expMonth: z.number().optional().openapi({
    description: 'Card expiration month.',
  }),
  expYear: z.number().optional().openapi({
    description: 'Card expiration year.',
  }),
  funding: z.string().optional().meta({
    description: 'Funding type for the payment method, such as debit or credit.',
  }),
});
